@if(loading){
<div class="loader">
    <div class="spinner-border project-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <p>Loading data...</p>
</div>
}

@if(buttonLoader){
<div class="btn-loader">
    <div class="spinner-border spinner-border-sm text-light" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <p>Loading...</p>
</div>
}